module.exports = __webpack_public_path__ + "img/NavWithApartmentLogo.ac28dd75.png";